import styles from './Timeline.module.css'

interface Props {
  index: number
}

export const TechnicianRowSkeleton = ({ index }: Props) => (
  <div
    className={`w-full flex items-stretch ${styles.skeletonRow}`}
    style={{ animationDelay: `${index * 80}ms` }}
  >
    {/* TechnicianInfo placeholder */}
    <div className="w-56 shrink-0 self-stretch p-3 bg-white outline outline-1 outline-offset-[-0.50px] outline-slate-200 flex items-center gap-3.5 sticky left-0 z-10">
      <div className="w-11 h-11 rounded-full bg-slate-200 shrink-0" />
      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <div className="h-3 bg-slate-200 rounded-sm w-24" />
        <div className="h-3 bg-slate-200 rounded-sm w-16" />
      </div>
    </div>

    {/* Timeline track placeholder */}
    <div className="flex-1 min-w-0 bg-white outline outline-1 outline-offset-[-0.50px] outline-slate-200 h-16 relative overflow-hidden">
      {/* Two "appointment" blobs, staggered per row */}
      <div
        className="absolute top-3 h-10 bg-slate-200 rounded"
        style={{ left: `${8 + (index % 3) * 5}%`, width: '14%' }}
      />
      <div
        className="absolute top-3 h-10 bg-slate-200 rounded"
        style={{ left: `${32 + (index % 2) * 8}%`, width: '18%' }}
      />
    </div>
  </div>
)
